import "./Dropdown.css";

const Dropdown = ({ label, options, value, onChange, ...props }) => {
  return (
    <div className="standard-select-dropdown form-group">
      <label className="standard-select-dropdown-label text-secondary">
        <strong>{label}</strong>
      </label>
      <select
        className="standard-select-dropdown form-control custom-select"
        value={value}
        onChange={onChange}
        {...props}
      >
        {options.map((option, index) => {
          const optionValue = option?.value || option;
          return (
            <option key={`${optionValue}-${index}`} value={optionValue}>
              {option?.label || option}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default Dropdown;
